export enum ProcessStatusEnum {
    NotStarted = 0,
    InProgress = 1,
    Complete = 2,
}
